/**
 * shell/ResearchDashboard.jsx  —  Vidyagni FSLP Research Dashboard
 * ─────────────────────────────────────────────────────────────────────────────
 * Across-Group View only. Per-Child View moved to its own page
 * (ResearchChildDashboard.jsx, routed at /research/children) — this file
 * used to hold both behind a tab switcher; splitting them was a deliberate
 * request, not a refactor for its own sake.
 *
 * One square per tracked variable (constants/researchVariables.js), grouped
 * by family. Clicking a square navigates to /research/variable/:id — a real
 * page per variable, not a fullscreen modal, so each one is bookmarkable and
 * has room for a methodology note next to its chart.
 */

import { Link } from "react-router-dom";
import { FAMILIES, TRACKED_VARIABLES } from "@/constants/researchVariables";

export default function ResearchDashboard() {
  return (
    <div style={{ padding: '28px 26px 80px', maxWidth: 1280, margin: '0 auto', fontFamily: "'Inter',system-ui,sans-serif" }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 12, marginBottom: 26 }}>
        <div>
          <div style={{ fontFamily: "'Playfair Display',serif", fontSize: 28, fontWeight: 900, color: 'var(--navy)', marginBottom: 5, lineHeight: 1 }}>
            Research Dashboard
          </div>
          <div style={{ fontSize: 13, color: 'var(--mist)' }}>
            Pilot study · growth over time across disability categories vs. typically developing children
          </div>
        </div>
        <Link to="/research/children" style={{
          display: 'flex', alignItems: 'center', gap: 7, padding: '9px 16px',
          background: 'var(--navy)', color: '#fff', borderRadius: 9,
          fontSize: 13, fontWeight: 700, textDecoration: 'none',
        }}>
          🧒 Per-Child View
        </Link>
      </div>

      {Object.entries(FAMILIES).map(([famKey, fam]) => {
        const vars = TRACKED_VARIABLES.filter(v => v.family === famKey);
        if (!vars.length) return null;
        return (
          <div key={famKey} style={{ marginBottom: 28 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
              <div style={{ width: 8, height: 8, borderRadius: 2, background: fam.color }} />
              <div style={{ fontSize: 12, fontWeight: 800, letterSpacing: 0.5, color: '#6B7280', textTransform: 'uppercase' }}>{fam.label}</div>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 12 }}>
              {vars.map(v => (
                <Link key={v.id} to={`/research/variable/${v.id}`} style={{
                  display: 'block', textDecoration: 'none', background: '#fff',
                  border: '1.5px solid #E5E7EB', borderRadius: 12, padding: '14px 16px',
                  borderTop: `3px solid ${fam.color}`, transition: 'box-shadow .15s, transform .15s',
                }}
                  onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 4px 14px rgba(0,0,0,.08)'; e.currentTarget.style.transform = 'translateY(-1px)'; }}
                  onMouseLeave={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'none'; }}
                >
                  <div style={{ fontWeight: 800, fontSize: 13, color: '#111827', marginBottom: 4 }}>{v.label}</div>
                  <div style={{ fontSize: 11, color: '#9CA3AF', marginBottom: 8 }}>{v.unit}</div>
                  {v.description && (
                    <div style={{ fontSize: 11, color: '#6B7280', lineHeight: 1.5 }}>{v.description}</div>
                  )}
                </Link>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}